import {X} from 'lucide-react'
import {Button} from '@/components/ui/button'
import {useI18n} from '@/i18n'

interface ClearFiltersButtonProps {
    hasActiveFilters: boolean
    onClick: () => void
    testId?: string
}

export function ClearFiltersButton({hasActiveFilters, onClick, testId = 'btn-clear-filters'}: ClearFiltersButtonProps) {
    const i18n = useI18n()
    return (
        <Button
            data-testid={testId}
            variant="ghost"
            size="sm"
            onClick={onClick}
            className={hasActiveFilters ? '' : 'invisible'}
        >
            <X className="h-4 w-4 mr-1"/>
            {i18n.common.clear}
        </Button>
    )
}
